import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, Observable } from 'rxjs';

import { environment } from '@environment';
import { Account } from '@models/account';
import { SetupInfo } from '@models/setup-info';

@Injectable({
    providedIn: 'root',
})
export class AccountService {
    private baseAccountUrl: string = environment.ApiBase + "account/";

    constructor(private _http: HttpClient) {}

    getAccountList(accountNumber: string = ''): Observable<Account[]> {
        if (!accountNumber || accountNumber.length === 0) {
            accountNumber = '';
        }
        let params: HttpParams = new HttpParams();
        params = params.append('accountNumber', accountNumber);
        return this._http.get<Account[]>(`${this.baseAccountUrl}list`, { params: params });
    }

    getReportsForAccount(accountNumber: string): Observable<string[]> {
        const params: HttpParams = new HttpParams({ fromObject: { accountNumber: accountNumber } });
        return this._http.get<string[]>(`${this.baseAccountUrl}reports`, { params: params });
    }

    getReportSetupForAccount(accountNumber: string, language: string): Observable<SetupInfo[]> {
        const params: HttpParams = new HttpParams({ fromObject: { accountNumber: accountNumber, languageISO: language } });
        return this._http.get<SetupInfo[]>(`${this.baseAccountUrl}report-setup`, { params: params });
    }

    async updateAccountReportLink(isAdd: boolean, account: Account, reportId: string): Promise<boolean> {
        const headers: HttpHeaders = new HttpHeaders({ "Content-Type": "application/json" });

        if (account && account.AccountNumber && reportId && reportId.length > 0) {
            const data = {
                addLink: isAdd,
                accountNumber: account.AccountNumber,
                reportId: reportId
            };

            return await lastValueFrom(this._http.post<boolean>(`${this.baseAccountUrl}report-link`, data, { headers: headers }));
        }

        return false;
    }

    // getCustomerAccountOptions(criteria: string): Observable<CustomerAccount[]> {
    //     const params: HttpParams = new HttpParams({ fromObject: { criteria: criteria, userId: '' } });
    //     return this._http.get<CustomerAccount[]>(this.baseUserUrl + "customer-accounts", { params: params });
    // }

    // getAccountsForUser(userId: string): Observable<Account[]> {
    //     // TODO: Update API to take userId as parameter and return accounts for that user
    //     const params: HttpParams = new HttpParams({ fromObject: { userId: userId } });
    //     return this._http.get<Account[]>(`${this.baseAccountUrl}user`, { params: params });
    // }
}
